import { EventTypes, track } from '@mc/track-event'

export type TrackingProps = {
  name: string
  location: string
  pageSource: string
}

export const trackClick = ({
  name,
  location,
  pageSource = '',
  question,
}: TrackingProps & { question: string }) => {
  if (name && location && question) {
    track(name, {
      category: 'faq',
      location,
      action: question,
      subscription_id: {},
      active_annual_pass: false,
      page_path: window.location.pathname,
      page_source: pageSource,
    })
  }
}

export const trackViewed = ({ pageSource = '' }: TrackingProps) => {
  track(EventTypes.FAQ_VIEWED, {
    category: 'faq',
    location: 'faq-section',
    action: 'viewed',
    subscription_id: {},
    active_annual_pass: false,
    page_path: window.location.pathname,
    page_source: pageSource,
  })
}
